import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import './DatePickerStyles.css';

require('react-datepicker/dist/react-datepicker.css');

const AppDatePicker = ({ value, onChange, inline, minDate, maxDate, readOnly = false }) => {
  const [date, setDate] = useState('');

  useEffect(() => {
    setDate(value);
  }, [value]);

  return (
    <DatePicker
      dateFormat="dd.MM.yyyy"
      selected={date}
      onChange={(thisDate) => {
        if (!readOnly) {
          setDate(thisDate);
          onChange(thisDate);
        }
      }}
      className="form-control disabled"
      inline={inline}
      minDate={minDate}
      maxDate={maxDate}
      showMonthDropdown
      showYearDropdown
      dateFormatCalendar=" " // hide calendar title
      dropdownMode="select"
      required
    />
  );
};

AppDatePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default AppDatePicker;
